import { render, staticRenderFns } from "./serviceHallHeader.vue?vue&type=template&id=72e5cb72&"
import script from "./serviceHallHeader.vue?vue&type=script&lang=js&"
export * from "./serviceHallHeader.vue?vue&type=script&lang=js&"
import style0 from "./serviceHallHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports